<!-- The root-filter component handles his own visibility (depending on brand, route, etc.) -->
<app-root-filter></app-root-filter>

<fuse-app-lessons-tab class="page-layout simple inner-scroll"
                      fxFlex
                      type="byRole"
                      [creatorsRolesFilter]="creatorsRolesFilter"
                      [selectedOption]="selectedOption">
</fuse-app-lessons-tab>